import { useFormContext } from 'react-hook-form'
import { useDateFormat } from '../../../../../hooks'
import { Calendar } from '../../../../forms'
import { isAfter, startOfMonth } from 'date-fns'
import { MergedAvailabilities } from '../../../../../types/mergedAvailabilities'
import { AppointmentFormData } from '../../../../../types'
import { CustomPickersDay } from 'components/CustomPickersDay'
import { PickersDayProps } from '@mui/lab'

interface Props {
  availabilities: MergedAvailabilities
  maxDate?: Date
}

const Day = ({ availabilities, maxDate }: Props) => {
  const { setValue, watch } = useFormContext<AppointmentFormData>()
  const [customerTimeZone] = watch(['timezone'])
  const { dateToISODateKey } = useDateFormat()

  const onMonthChange = (date: Date | null) => {
    const currentDate = new Date()
    const firstDayOfMonth = startOfMonth(date ?? currentDate)
    const dateStart = isAfter(currentDate, firstDayOfMonth) ? currentDate : firstDayOfMonth
    setValue('month_date', firstDayOfMonth)
    setValue('start_date', dateStart)
    setValue('clientStartDate', dateStart)
  }

  const renderDay = (date: Date, _: Date[], pickersDayProps: PickersDayProps<unknown>) => {
    const dateKey = dateToISODateKey(date)

    const isDisabled = pickersDayProps.disabled
    if (isDisabled) return <CustomPickersDay {...pickersDayProps} dayState={'DISABLED'} />

    const noAvailabilityForDate = !availabilities || Object.keys(availabilities).length === 0 || !availabilities[dateKey]
    if (noAvailabilityForDate) return <CustomPickersDay {...pickersDayProps} dayState={'NOT_AVAILABLE'} />

    const isPartialDay = availabilities[dateKey].length === 0
    if (isPartialDay) return <CustomPickersDay {...pickersDayProps} dayState={'PARTIAL'} />

    return <CustomPickersDay {...pickersDayProps} dayState={'AVAILABLE'} />
  }

  return (
    <Calendar
      customerTimeZone={customerTimeZone}
      name="clientStartDate"
      maxDate={maxDate}
      onMonthChange={onMonthChange}
      renderDay={renderDay}
    />
  )
}

export { Day }
